import React from 'react';
import {compose} from "redux";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {empty} from "../../state/utils/Common";
import manager_roles from "../../state/utils/data/application_manager_user_roles_flat.json"

/**
 * Reduxステート（これはコンポーネントのパラメータに挿入されます。)
 * @param state - reduxルートクラス
 */
const mapStateToProps = state => {
    return {
        managerProfile: state.root.managerProfile,
    }
}

/**
 * Reduxアクション（これもコンポーネントのパラメータに挿入されます。)
 */
const mapEventToProps = {}

/**
 * 編集可能チェック
 *
 * @returns {JSX.Element}
 * @constructor
 */
const _restrictSystem = (
    {
        managerProfile,
        children
    }
) => {
    if(!empty(managerProfile) && managerProfile?.role_type !== manager_roles.System) {
        return (children)
    }
    return (<></>)
};

/**
 *
 * * Redux
 * * i18next Translations
 * を
 * UserView コンポーネントに追加する。
 */
const RestrictSystem = compose(
    connect(mapStateToProps, mapEventToProps),
    withTranslation('common'))(_restrictSystem)

export default RestrictSystem;
